import { BehaviorSubject } from 'rxjs';

export const ToastSubject$ = new BehaviorSubject({
  skin: '',
  content: '',
});

export const getToast$ = () => ToastSubject$;
export const setToast$ = (Toast: any) => ToastSubject$.next(Toast);
